// extracted by mini-css-extract-plugin
export default {"sendbutton":"sendbutton_ec6067d00c5bdeefa9d8"};